import { View, Image, ImageBackground, Text, StyleSheet } from "react-native";
import {
  ChipsTitle,
  CircleBlue,
  CircleGold,
  CircleGreen,
  LosesTitle,
  StatisticsDownLightPng,
  WinsTitle,
} from "../../../assets";
import { isPortrait } from "../../../utils/common";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useTranslation } from "react-i18next";
import { selectProfile } from "../../../store/auth/authReducer";

type ProfileUser = {
  username: string;
  avatarFileId: string | null;
  chips: number;
  level: number;
};

type CircleButtonsProps = {
  user?: ProfileUser;
};

const CircleButtons: React.FC<CircleButtonsProps> = ({ user }) => {
  const loggedUser = useSelector(selectProfile);
  const effectiveUser = user ?? loggedUser;
  if (!effectiveUser) return null;
  const { t } = useTranslation();
  const gamesData = useSelector((s: RootState) => s.auth.statistics?.gamesData);

  return (
    <View
      style={[
        styles.container,
        {
          paddingTop: isPortrait ? 6 : 0,
          paddingBottom: isPortrait ? 0 : 0,
        },
      ]}
    >
      {/* WINS */}
      <View style={styles.item}>
        <View style={styles.textRow}>
          <Image
            source={StatisticsDownLightPng}
            style={styles.statisticsLight}
          />
          <Text style={[styles.text, { fontSize: isPortrait ? 13 : 16 }]}>
            {t("T_SITE_PROFILE_WINS")}
          </Text>
          <Image
            source={StatisticsDownLightPng}
            style={styles.statisticsLight}
          />
        </View>
        <ImageBackground
          source={CircleGold}
          style={[
            styles.circle,
            { width: isPortrait ? 110 : 130, height: isPortrait ? 110 : 130 },
          ]}
          resizeMode="contain"
        >
          <Text style={styles.goldText}>{gamesData?.svarka_wins}</Text>
        </ImageBackground>
      </View>

      {/* LOSES */}
      <View style={styles.item}>
        <View style={styles.textRow}>
          <Image
            source={StatisticsDownLightPng}
            style={styles.statisticsLight}
          />
          <Text style={[styles.text, { fontSize: isPortrait ? 13 : 16 }]}>
            {" "}
            {t("T_SITE_PROFILE_LOSES")}
          </Text>
          <Image
            source={StatisticsDownLightPng}
            style={styles.statisticsLight}
          />
        </View>
        <ImageBackground
          source={CircleBlue}
          style={[
            styles.circle,
            { width: isPortrait ? 110 : 130, height: isPortrait ? 110 : 130 },
          ]}
          resizeMode="contain"
        >
          <Text style={styles.blueText}>{gamesData?.svarka_loses}</Text>
        </ImageBackground>
      </View>

      {/* CHIPS */}
      <View style={styles.item}>
        <View style={styles.textRow}>
          <Image
            source={StatisticsDownLightPng}
            style={styles.statisticsLightChips}
          />
          <Text style={[styles.text, { fontSize: isPortrait ? 13 : 16 }]}>
            {t("T_SITE_PROFILE_CHIUPS_GAINED")}
          </Text>
          <Image
            source={StatisticsDownLightPng}
            style={styles.statisticsLightChips}
          />
        </View>

        <ImageBackground
          source={CircleGreen}
          style={[
            styles.circle,
            { width: isPortrait ? 110 : 130, height: isPortrait ? 110 : 130 },
          ]}
          resizeMode="contain"
        >
          <Text style={styles.blueText}>{gamesData?.svarka_chips_wins}</Text>
        </ImageBackground>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  item: {
    alignItems: "center",
    flex: 1,
  },
  textRow: {
    marginTop: 10,
    marginBottom: 8,
  },
  text: {
    fontSize: 16,
    fontWeight: "600",
    letterSpacing: 1.1,
    color: "#E0E0E0",
    textShadowColor: "rgba(0, 0, 0, 0.6)",
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 2,
    textTransform: "uppercase",
    paddingBottom: 2,
    textAlign: "center",
  },
  statisticsText: {
    width: 112,
    height: 21,
  },
  statisticsLight: {
    width: 90,
    height: 2,
  },
  statisticsLightChips: {
    width: 130,
    height: 2,
  },
  chipsImage: {
    width: 90,
    height: 24,
    maxWidth: "90%",
  },
  circle: {
    justifyContent: "flex-end",
    alignItems: "center",
    paddingBottom: 15,
  },
  goldText: {
    fontSize: 20,
    marginBottom: 22,
    fontWeight: "bold",
    color: "#fff",
    textShadowColor: "#FFD700",
    textShadowOffset: { width: 0, height: 0 },
    textShadowRadius: 6,
  },
  blueText: {
    fontSize: 20,
    marginBottom: 22,
    fontWeight: "bold",
    color: "#fff",
    textShadowColor: "#000",
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 3,
  },
});

export default CircleButtons;
